<div class="modal-header">
    <h3 class="modal-title">Entity CleanUp</h3>
    <div class="header-actions">
        <i (click)="minimise = !minimise" class="fa"
           (keydown.enter)="minimise = !minimise"
           (keydown.space)="minimise = !minimise; $event.preventDefault()"
           [class.fa-plus-square-o]="minimise"
           [class.fa-minus-square-o]="!minimise"
           title="Minimize or expand"
           aria-label="Minimize or expand"
           role="button"
           tabindex="0"></i>
        <i (click)="cancel()" class="fa fa-times"
           (keydown.enter)="cancel()"
           (keydown.space)="cancel(); $event.preventDefault()"
           title="Close"
           aria-label="Close"
           role="button"
           tabindex="0"></i>
    </div>
</div>
<div [hidden]="minimise">
@if (isLoading) {
<mat-progress-bar color="primary" mode="indeterminate">
</mat-progress-bar>
}
<div class="ap-mt-spacing-6">
    <div class="col-12">
        <ap-panel [bordered]='true' [title]="'Entity List'">
            <div class="col-12 gray-container table-content">
                <div class="max-height table-scroll">
                    <section>
                        <div>
                            <table class="table table-hover table-bordered table-striped table-condensed cleanup-table">
                                <thead class="a-thead">
                                    <tr>
                                        <th></th>
                                        <th>Source System</th>
                                        <th>LEID</th>
                                        <th>Tax Code</th>
                                        <th>Reporting Period</th>
                                        <th>ME Code</th>
                                        <!-- <th>LE Key</th> -->
                                        <th>LE Type</th>
                                        <th>Trading Partners</th>
                                        <th>Partner for Partnerships/ Partnership for Partners</th>
                                        <th>Transactions to be Deleted</th> <!-- Delete Transaction -->
                                        <th>Trans details Dropdown with Count</th>


                                    </tr>
                                </thead>
                                @if (allEntityDetails.length > 0) {
<tbody class="a-tbody tbody-regular tbody-hover">
                                    @for (item of allEntityDetails; track $index; let i = $index) {

                                        <tr [hidden]="item.display == false">
                                            <td class="parentCell"
                                                ap-tooltip [appendAfterTarget]="true" [tooltipContent]="item.message"
                                                direction="right">
                                                @if (item.IS_PARENT == 'N') {
<div>
                                                    <ap-checkbox
                                                        (onChange)="selectEntity($event, item)"
                                                        [disabled]="item.IS_CKB_DISABLED === 'Y' || item.TP_KEY_DTLS_COUNT != 0 || item.PSHIP_DTLS_COUNT != 0 ? true : false">
                                                    </ap-checkbox>
                                                </div>
}
                                                @if (item.IS_PARENT == 'Y' && item.PLUS == true) {
<div>
                                                    <ap-button class="plus-btn" [compact]="true"
                                                        [btnType]="'text'" (onClick)="expandRow(i)">
                                                        <span class="Appkit4-icon a-btn-icon icon-plus-fill"></span>
                                                    </ap-button>

                                                </div>
}

                                                @if (item.IS_PARENT == 'Y' && item.PLUS == false) {
<div>
                                                    <ap-button class="plus-btn" [compact]="true"
                                                        [btnType]="'text'" (onClick)="collapseRow(i)">
                                                        <span class="Appkit4-icon a-btn-icon icon-minus-fill"></span>
                                                    </ap-button>

                                                </div>
}
                                            </td>
                                            <td>

                                                {{item.SOURCE_SYSTEM_FLAG =='D'? 'Domestic' : 'Foreign'}}

                                            </td>
                                            <td class="width-entity">

                                                {{item.LEID}}

                                            </td>
                                            <td>{{item.CDR_NO}}</td>
                                            <td>{{item.REPORTING_PERIOD}}</td>
                                            <td>{{item.ME_CODE ? item.ME_CODE : ''}}</td>
                                            <!-- <td>{{item.LE_KEY}}</td> -->
                                            <td>{{item.LE_TYPE}}</td>
                                            <td>{{item.TP_KEY_DTLS_COUNT ? item.TP_KEY_DTLS_COUNT : '0' }}
                                            </td>
                                            <td>{{ item.PSHIP_DTLS_COUNT ? item.PSHIP_DTLS_COUNT : '0' }}
                                            </td>
                                            <td>
                                                {{item.TRANS_COUNT}}
                                            </td>
                                            <td>
                                                @if (item.TRANS_COUNT != 0) {
<mat-select name="transCount">
                                                    @for (count of optionsTransCount; track $index) {

                                                        @if (item.AGG_COMBINATION_KEY == count.AGG_COMBINATION_KEY;) {
<mat-option
                                                            [value]="count.TRANS_TYPE_KEY">
                                                            {{count.TRANS_DETAILS}}
                                                        </mat-option>
}
                                                    
}
                                                </mat-select>
}
                                                @if (item.IS_PARENT == 'Y' && item.TRANS_COUNT == 0) {


                                                
}
                                                @if (item.IS_PARENT == 'N' && item.TRANS_COUNT == 0) {

                                                    No transactions to Delete
                                                
}
                                            </td>

                                        </tr>
                                    
}
                                </tbody>
}
                                @if (allEntityDetails.length == 0 && !isLoading) {
<tbody class="a-tbody tbody-regular tbody-hover"
                                   >
                                    <tr>
                                        <td colspan="11" class="text-sm-center">No Record</td>
                                    </tr>
                                </tbody>
}
                            </table>
                        </div>
                    </section>
                </div>

            </div>
        </ap-panel>
        <div class="footer-actions">
            <ap-button [label]="'CANCEL'" class="cancel-button ap-mr-spacing-3" [btnType]="'secondary'"
                (onClick)="cancel()"></ap-button>
                <ap-button [label]="'DELETE'" class="delete-button ap-mr-spacing-3" [btnType]="'primary'" [disabled]="!enableButton"
                    (onClick)="deleteEntities()"></ap-button>
        </div>
    </div>

</div>
</div>
